<template>
    <section
        class="bg-black-700 full-width relative tablet:h-screen tabletLandscape:h-auto desktop:h-screen flex flex-col desktop:flex-row relative">
        <!--Image Background-->
        <background-image
            :key="currentSlide"
            :srcset="sectionTestimonials.slides[currentSlide].featured_image_src_set"
            :src="sectionTestimonials.slides[currentSlide].featured_image_url"
            :fallback-image="sectionTestimonials.slides[currentSlide].featured_image_url"
            :alt="sectionTestimonials.slides[currentSlide].name_line_1"
            :with-gradient="false"
            class="h-min-screen object-cover"
        />

        <!--Content Layout in a Container-->
        <div
            class="container flex phone:h-screen phone:justify-end flex-grow z-10 pt-8 tablet:pt-16 pb-16 tablet:items-end">
            <!--Aside Block -- Content Text Aside Component -- Matches Layout Spacer div below for sizing/spacing-->
            <div class="section-content flex phone:flex-col">
                <!--Aside Text Component-->
                <content-text-aside class="phone:w-1/2 mobile:flex-grow tablet:w-1/4 max-w-xxs mr-10 desktop:mr-32 desktop:pl-4">
                    <template #title-text>
                        <span class="text-white">{{ sectionTestimonials.testimonialsContent.asideTitle }}</span>
                    </template>
                </content-text-aside>

                <!--Content Block  -->
                <div
                    class="section-text flex flex-col items-start tablet:max-w-xs tabletLandscape:max-w-md desktop:max-w-lg">
                    <!--Content Text Component-->
                    <content-text>
                        <template #title-text>
                            <h2
                                class="font-light"
                                v-html="sectionTestimonials.testimonialsContent.title"></h2>
                        </template>
                        <template #content-text>
                            <div
                                class="font-regular mb-6"
                                v-html="sectionTestimonials.testimonialsContent.content">
                            </div>
                        </template>
                    </content-text>
                </div>
            </div>
        </div>

        <!--Testimonial Block-->
        <div
            class="testimonials transition-all duration-200 z-10 py-10 px-16 self-center flex flex-col text-white relative
        tablet:px-14 tablet:justify-center
        desktop:w-1/2 desktop:max-w-2xl desktop:mb-10 desktop:ml-4 desktop:h-auto desktop:max-w-lg desktop:px-14 desktop:py-16
        hd:h-auto hd:w-1/2 hd:max-w-3xl hd:px-20 hd:py-24 hd:ml-32"
            :style="{ backgroundColor: sectionTestimonials.slides[currentSlide].background_color }">
            <img
                :src="sectionTestimonials.slides[currentSlide].logo_image_url"
                :alt="sectionTestimonials.slides[currentSlide].name_line_1"
                class="w-35 pb-4 hd:pb-12">
            <div class="testimonial relative">
                <svg-icon
                    icon="quotes"
                    class="quotes-icon absolute" />
                <p class="content">
                    {{ sectionTestimonials.slides[currentSlide].quote }}
                </p>
                <div class="testimonial-author pt-5 uppercase tracking-wider">
                    <span
                        v-if="sectionTestimonials.slides[currentSlide].name_line_1"
                        class="name font-bold">
                        {{ sectionTestimonials.slides[currentSlide].name_line_1 }}
                    </span><span v-if="sectionTestimonials.slides[currentSlide].name_line_2">,</span>
                    <br v-if="sectionTestimonials.slides[currentSlide].name_line_2">
                    <span
                        v-if="sectionTestimonials.slides[currentSlide].name_line_2"
                        class="company font-bold">
                        {{ sectionTestimonials.slides[currentSlide].name_line_2 }}
                    </span>
                </div>
            </div>
            <div
                class="testimonial-controls flex pt-10 desktop:absolute desktop:bottom-0 desktop:inset-x-0 desktop:-bottom-70">
                <span
                    v-for="(slide, index) in sectionTestimonials.slides"
                    :key="index"
                    class="pr-6 cursor-pointer desktop:border desktop:py-3 desktop:px-4 desktop:border-l-0 desktop:first:border-l desktop:opacity-75"
                    :class="{'font-bold desktop:bg-white desktop:border desktop:border-white desktop:text-gold-500 desktop:opacity-100'
                        :(currentSlide === index )}"
                    @click="handleSlideChange(index)">0{{ index+1 }}
                </span>
            </div>
        </div>
    </section>
</template>

<script>
import ContentText from '@web/components/ContentText';
import ContentTextAside from '@web/components/ContentTextAside';
import BackgroundImage from '@web/components/BackgroundImage';
import TisButton from '@whisper/components/buttons/TisButton';
import SvgIcon from '@whisper/components/icons/SvgIcon';

export default {
  components: {
    TisButton,
    SvgIcon,
    ContentText,
    BackgroundImage,
    ContentTextAside,
  },
  props: {
    sectionTestimonials: {
      type: Object,
      required: true,
      testimonialsContent: {
        type: Object,
        required: true,
      },
      slides: {
        type: Array,
        required: true,
      },
    },
  },
  data: () => ({
    currentSlide: 0,
  }),
  methods: {
    handleSlideChange(slideIndex) {
      this.currentSlide = slideIndex;
    },
  },
};
</script>

<style scoped lang="scss">
    .quotes-icon {
        left: -28px;
        top: 3px;
    }
</style>
